import { shouldDisplayFinalPriceUpfront } from '../experiments/finalPriceUpfront';
import { SERVICE_FEE_FACTOR, TRANSACTION_FEE, TRANSACTION_FEE_THRESHOLD } from './constants';

/**
 * Calculate gig price including service fee (5.5% from the gig price) and transaction fee ($2) for the provided gig price.
 * @param {number} price gig price before service fee
 * @returns {number} gig price including fees (if in test) or the original price (if not in test)
 */
export const getPriceWithServiceFee = (price) => {
    const calcFinalPriceUpfront = shouldDisplayFinalPriceUpfront();

    if (calcFinalPriceUpfront) {
        const transactionFee = price < TRANSACTION_FEE_THRESHOLD ? TRANSACTION_FEE : 0;

        return price * SERVICE_FEE_FACTOR + transactionFee;
    } else {
        return price;
    }
};

/**
 * Calculate service fee (5.5% from the gig price) and transaction fee ($2) for the provided gig price.
 * @param {number} price gig price
 * @returns {number} fees to be applied on gig
 */
export const calcServiceFee = (price) => getPriceWithServiceFee(price) - price;
